import {
  AttachMoney,
  Block,
  BrowserNotSupported,
  Cancel,
  MoneyOff,
  PieChartOutline,
} from '@mui/icons-material';
import { Chip } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { InvoiceStatus } from '../common/enums/enums';

const PREFIX = 'PaymentStatus';

const classes = {
  defaultChip: `${PREFIX}-defaultChip`,
};

const StyledChip = styled(Chip)(({ theme }) => ({
  [`&.${classes.defaultChip}`]: {
    color: theme.palette.grey[400],
    '& .MuiSvgIcon-root': {
      color: theme.palette.grey[400],
    },
  },
}));

const canceledStatusHandler = (onlyText, detail, t) => {
  if (detail)
    return (
      <>
        {onlyText ? (
          t('paymentStatus.notApplicable')
        ) : (
          <Chip
            className={classes.defaultChip}
            icon={<Block />}
            label={t('paymentStatus.notApplicable')}
            variant="outlined"
          />
        )}
      </>
    );
  return (
    <>
      {onlyText ? (
        t('paymentStatus.canceled')
      ) : (
        <Chip
          icon={<Cancel />}
          label={t('paymentStatus.canceled')}
          color="error"
          variant="outlined"
        />
      )}
    </>
  );
};

const handleByAmountUnpaid = (amount, unpaid, onlyText, t) => {
  if (unpaid > 0 && unpaid < amount) {
    return (
      <>
        {onlyText ? (
          t('paymentStatus.partiallyPaid')
        ) : (
          <Chip
            icon={<PieChartOutline />}
            label={t('paymentStatus.partiallyPaid')}
            color="warning"
            variant="outlined"
          />
        )}
      </>
    );
  } else if (amount > 0 && unpaid >= amount) {
    return (
      <>
        {onlyText ? (
          t('paymentStatus.notPaid')
        ) : (
          <Chip
            icon={<MoneyOff />}
            label={t('paymentStatus.notPaid')}
            color="error"
            variant="outlined"
          />
        )}
      </>
    );
  } else if (amount > 0 && unpaid <= 0) {
    return (
      <>
        {onlyText ? (
          t('paymentStatus.paid')
        ) : (
          <Chip
            icon={<AttachMoney />}
            label={t('paymentStatus.paid')}
            color="success"
            variant="outlined"
          />
        )}
      </>
    );
  } else {
    return (
      <>
        {onlyText ? (
          t('paymentStatus.noValue')
        ) : (
          <StyledChip
            className={classes.defaultChip}
            icon={<BrowserNotSupported />}
            label={t('paymentStatus.noValue')}
            variant="outlined"
          />
        )}
      </>
    );
  }
};

const GenPaymentStatus = ({
  amount,
  unpaid,
  onlyText = false,
  status,
  detail = false,
  isInvoice = false,
}) => {
  const { t } = useTranslation('global');
  const chipHandler = () => {
    if (status === InvoiceStatus.CANCELED) {
      return canceledStatusHandler(onlyText, detail, t);
    }
    if (isInvoice && status === InvoiceStatus.PARTIALLY_PAID && unpaid <= 0) {
      return onlyText ? (
        t('paymentStatus.partiallyPaid')
      ) : (
        <Chip
          icon={<PieChartOutline />}
          label={t('paymentStatus.partiallyPaid')}
          color="warning"
          variant="outlined"
        />
      );
    }
    return handleByAmountUnpaid(amount, unpaid, onlyText, t);
  };
  return <>{chipHandler()}</>;
};

export default GenPaymentStatus;
